module.exports = __webpack_public_path__ + "media/creativeMedia/panel-1.1-89d32700.jpg";